import { useTranslation } from 'react-i18next';
import { AddressTypes, ErrorType } from '../../../../../global-types';
import { capitalize } from '../../../../../utils';
import {
  addressStatus,
  UseAddressValidationTextProps,
  UseAddressValidiationTextReturn,
} from '../address-confirmation-types';
import { errorMessageKeyMap } from './error-message-key-map';

/**
 * Concatenates and returns the validation title,body text, and address type to display based on the address status.
 * @param currentValidationAddress - The current address to validate
 * @returns title,body text, and address type to display based on the address status.
 */
export const useAddressValidationText = ({
  currentValidationAddress,
}: UseAddressValidationTextProps): UseAddressValidiationTextReturn => {
  const { t } = useTranslation();

  // Check if the address is incomplete or invalid, and set the status accordingly
  const isIncomplete = currentValidationAddress.errorType === ErrorType.Incomplete;
  const addressStatusStr = isIncomplete ? addressStatus.INCOMPLETE : addressStatus.INVALID;
  // Get the address type; Sender or Recipient, and display the appropriate message (Return for Sender, Recipient for Recipient)
  const addressType = currentValidationAddress.addressType;
  const addressTypeDisplay = addressType === AddressTypes.SENDER ? 'return' : addressType;
  // Concatenate validation title
  const validationTitle = t('addressConfirmation.addressConfirmationTitle', {
    addressStatus: capitalize(addressStatusStr),
    addressType: addressTypeDisplay,
  });
  // Resolve the validation body text key from the error code, falling back to the generic invalid message for unknown codes
  const validationMessageKey =
    errorMessageKeyMap[currentValidationAddress.errorType] ?? 'addressConfirmation.invalidAddressMessage';

  return { validationTitle, validationMessageKey };
};
